import styled from 'styled-components';
import { Input } from 'antd';

export const InputWrapper = styled(Input)`
	height: 40px !important;
	font-size: 16px !important;
	font-weight: 400 !important;
	line-height: 40px !important;
	padding: 5px 12px !important;
	border-radius: 4px !important;
	border: 1px solid ${({ theme }) => theme.palette.secondary['150']};
`;
